const { ccclass, property } = cc._decorator;
import ViewBase from "../../../../framework/core/mvvm/view_base";
import TextureManager from "../../../../manager/texture_manager";
import { threadId } from "worker_threads";
import AppData from '../../../public/const/app_data';

@ccclass
export default class GameRuleView extends ViewBase {
    @property(cc.Sprite)
    ruleSprs:cc.Sprite[] = []

    @property(cc.ScrollView)
    ruleScrollView:cc.ScrollView = null

    @property(cc.Node)
    bg:cc.Node = null

    @property(cc.Node)
    bgHJK:cc.Node = null

    @property(cc.ScrollView)
    ruleScrollViewHJK:cc.ScrollView = null

    @property(cc.Sprite)
    ruleSprsHJK:cc.Sprite[] = []

    gameNameByCount: { [key: string]: number; } = {
        "YXX":1,//暂时不显示彩池的规则
        "TB":2,//暂时不显示彩池的规则
        "LHD":1,
        "DZPK":1, 
        "HJK":3,
        "QZNN":1, 
        "JD":1, 
        "BP":2,
        "JK":2,
        "CP":1,
        "BJL":5,
        "Q2":1,
    }

    initItems() {
        let scrollv  = this.ruleScrollView
        let rulespr = this.ruleSprs
        let gameSimpleName = AppData.gameSimpleName == "BPZD" ? "BP" : AppData.gameSimpleName
        if (AppData.gameSimpleName == "HJK"){
            scrollv = this.ruleScrollViewHJK
            rulespr = this.ruleSprsHJK
            this.ruleScrollView.node.active = false
            this.bg.active = false
            this.ruleScrollViewHJK.node.active = true
            this.bgHJK.active = true
        }
        else{
            this.ruleScrollView.node.active = true
            this.bg.active = true
            this.ruleScrollViewHJK.node.active = false
            this.bgHJK.active = false
        }
        // this.ruleSpr.spriteFrame = this.ruleSprFrameHolder.getSpriteFrameByKey(gameName)
        scrollv.scrollToTop(0)
        for (let index = 0; index < 3; index++) {
            const ruleSpr = rulespr[index];
            ruleSpr.node.active = false
            if (this.gameNameByCount[gameSimpleName] >= (index+1)){
                this.loadRes("image/gamerule/TM_" + gameSimpleName + "_" + (index+1), (error, spr)=>{
                    ruleSpr.spriteFrame = spr
                    ruleSpr.node.active = true
                }, cc.SpriteFrame)
            }
        }
    }

}

